export default "__VITE_ASSET__7265d964__"